import { Divider, NavLink, Text } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { IconChevronRight } from '@tabler/icons-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import type React from 'react';
import type { NavbarDataProps } from '../../hooks/useNavbarItems';
import classes from './NavbarItem.module.css';
import { NavbarSubItem } from './NavbarSubItem';
export type NavbarItemProps = NavbarDataProps & {
  index: number;
  iconSize?: number;
  IconStroke?: number;
  handleItemClick?: (path: string) => void;
};
export const NavbarItem: React.FC<NavbarItemProps> = ({
  icon,
  label,
  active,
  href,
  items,
  onClick,
  handleItemClick
}) => {
  const {
    ref,
    entry
  } = useIntersection();
  const Icon = icon || null;
  const router = useRouter();
  const handleClick = (path: string) => {
    onClick?.();
    handleItemClick?.(path);
    router.push(path);
  };
  return label === 'SEPARATOR' ? <Divider my="md" /> : <NavLink label={<Text fw={700} fz={12} tt="uppercase">
          {label}
        </Text>} key={label} active={active} opened={active} leftSection={Icon} rightSection={items && <IconChevronRight size={20} stroke={2} color="var(--icon-color)" className="mantine-rotate-rtl" />} onClick={() => handleClick(href || '')} classNames={classes} component={Link} href={href || '#'} ref={ref} styles={{
    collapse: {
      top: entry?.boundingClientRect.top,
      left: entry?.boundingClientRect ? entry?.boundingClientRect.left + entry?.boundingClientRect.width : 'auto'
    }
  }}>
      {items && <NavbarSubItem label={label} data={items} />}
    </NavLink>;
};